// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3zq13","emails":"CreateEditClinics_emails__1BVw8","emailTagLabel":"CreateEditClinics_emailTagLabel__23RG-"};